import { render, staticRenderFns } from "./popupCard.vue?vue&type=template&id=5dacb532&"
import script from "./popupCard.vue?vue&type=script&lang=js&"
export * from "./popupCard.vue?vue&type=script&lang=js&"
import style0 from "../style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports